import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from '@/App'
import '@/index.css'
import '@/styles/cabina.css'
import { useSession } from '@/store/session'

/**
 * Escape hatch SOLO de desarrollo para el bucle de fidelidad visual: con
 * `?preview` en la URL e `import.meta.env.DEV`, inyecta una sesión ficticia
 * para que la app autenticada se pueda renderizar/capturar sin login real.
 * No tiene NINGÚN efecto en producción (guardado por DEV + query param).
 */
if (import.meta.env.DEV && new URLSearchParams(window.location.search).has('preview')) {
  if (!useSession.getState().session) {
    useSession.getState().setSession({
      user: { id: 'preview', email: 'nico@mapeodata.com', created_at: new Date().toISOString() },
      access_token: 'preview',
      refresh_token: 'preview',
      expires_at: Date.now() + 3600_000,
    })
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
